var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MNotification'),_c('OHeader'),_c('main',[_c('transition',{attrs:{"name":"router-anim","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view',{staticClass:"min-height"})],1)],1),_c('OFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }